import "./LogoDiv.scss";

export default function LogoDiv() {
    return (
        <div className='logo-container'>
            <img
                className='logo-image'
                src='/loginpage/main-logo.svg'
                alt='Logo'
            />
        </div>
    );
}
